module.exports = __webpack_public_path__ + "img/marketing.fdc71fa4.svg";